<template>
  <div id="mains" v-if="divVisible">
    <b>メイン画面</b><br/><br/>

    <table>
      <tr>
        <td>リンク一覧を参照いただきます。</td>
      </tr>
    </table><br/>

    <div v-if="user.userType == '1' || user.userType == '3' ">
      <router-link :to="{ name: 'projects', params: { } }">プロジェクト情報一覧</router-link><br/><br/>
      <router-link :to="{ name: 'sales', params: { } }">管理人月数情報一覧</router-link><br/><br/>
      <router-link :to="{ name: 'questionnaireAnswer',params: { } }">評価結果一覧（全員）</router-link><br/><br/>
      <router-link :to="{ name: 'questionnaire', params: { backScreenId: 'mains' } }">評価実施</router-link><br/><br/>
      <router-link :to="{ name: 'questionnaireStatus', params: { } }">評価状況一覧</router-link><br/><br/>
      <br/><br/>
      <router-link :to="{ name: 'eloBatch', params: { } }">ELOバッチ実行</router-link><br/><br/>
      <router-link :to="{ name: 'questionnaireItemManage', params: { } }">評価項目管理（工事中）</router-link><br/><br/>
      <router-link :to="{ name: 'userManage', params: { } }">ユーザ管理</router-link><br/><br/>
      <router-link :to="{ name: 'syncAWS', params: { } }">AWS同期</router-link><br/><br/>
    </div>

    <div v-else-if="user.userType == '5'">
      <router-link :to="{ name: 'sales', params: { } }">管理人月数情報一覧（自己）</router-link><br/><br/>
      <router-link :to="{ name: 'questionnaire', params: { backScreenId: 'mains' } }">評価実施</router-link><br/><br/>
      <router-link :to="{ name: 'questionnaireAnswer',params: { evaluateeMemberID: user.memberID } }">評価結果一覧（自己）</router-link><br/><br/>
      <br/>
    </div>

    <div v-else-if="user.userType == '7'">
      <router-link :to="{ name: 'questionnaire', params: { backScreenId: 'mains' } }">評価実施</router-link><br/><br/>
      <router-link :to="{ name: 'questionnaireAnswer',params: { evaluateeMemberID: user.memberID } }">評価結果一覧（自己）</router-link><br/><br/>
    </div>

    <div v-else-if="user.userType == '9'">
      <router-link :to="{ name: 'questionnaire', params: { backScreenId: 'mains' } }">評価実施</router-link><br/><br/>
    </div>

    <div v-else-if="user.userType == '8'">
      <router-link :to="{ name: 'questionnaireStatus', params: { } }">評価状況一覧</router-link><br/><br/>
    </div>
  </div>
</template>

<script>
  export default {
    name: "mains",
    data() {
      return {
          divVisible: false,
          user:  { memberID: '', memberName: '', userType: '', deleteFlg: '' },
          //heads: [ ],
          //rows:  [ ],
      }
    },
    mounted() {
      const s = document.createElement('script');
      s.type = 'text/javascript';
      s.src = '/static/js/common.js?v=17';
      document.body.appendChild(s);
      this.init();
    },
    methods: {
      init: function () {
        var self = this;

        // サーバ側処理呼び出す
        new Promise(function (request, response) {
          var data = self.$route.params;
          common.getAxios().post(process.env.API_URL +"/api/MainsInit", data )
            .then(function (res) {
              if (res.data) {
                self.user = res.data.user;

                self.divVisible = true;
              }
            })
            .catch(function (err) {
              alert(err);
            });
        });

      },
    }

  };
</script>



// WEBPACK FOOTER //
// mains.vue?1521cd20